export const platformAdminNavigation = {
  links: {
    portal: "Portal",
    platformAdmin: "Platform Admin",
    examAdmin: "Exam Admin",
  },
  menu: {
    domainOverview: "Overview",
    domainPortal: "Portal",
    domainGovernance: "Governance",
    domainResource: "Resources",
    domainRuntime: "Runtime",
    domainCapability: "Capabilities",
    dashboard: "Overview",
    applications: "Business Entries",
    portalManagement: "Portal Management",
    portalGroups: "Portal Groups",
    portalAppearance: "Portal Appearance",
    portalUiSemantics: "UI Semantics",
    portalEntries: "Entry Orchestration",
    portalAccess: "Access Settings",
    portalSecurity: "Security Policies",
    identity: "Identity",
    identityApplications: "Identity Applications",
    identityUsers: "Platform Users",
    identityTenants: "Tenants",
    identityOrganizations: "Organizations",
    identityRoles: "Platform Roles",
    identityPermissions: "Permissions",
    identityEvents: "Identity Audit",
    identityLoginRecords: "Login Records",
    identityUserCustomFields: "User Custom Fields",
    assets: "Assets",
    execution: "Execution",
    centers: "Platform Entries & Centers",
  },
} as const;
